<template>
    <v-container fluid style="height: 100%; overflow: auto">
        <router-view></router-view>
    </v-container>
</template>

<script>
// import { ref, onMounted, computed } from "vue";
// import { useStore } from "vuex";

export default {
    name: "service-layout",
    components: {},
    setup() {
        // onMounted(() => {
        //     // store.dispatch("getProductList");
        // });

        return {};
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}
</style>
